import type { IconSvgObject } from './types';

const FolderOffIcon: IconSvgObject = [
  ["path", { d: "M7 3L8.0044 3C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V18M21 21H4C2.89543 21 2 20.1046 2 19V4.75C2 4.0519 2.40876 3.44927 3 3.16841", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderOffIcon;
